module.exports = __webpack_public_path__ + "img/icon-delete.d3419daf.svg";